// extracted by mini-css-extract-plugin
export var closeButton = "_63-0";